/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-array-index-key */
/* eslint-disable max-len */
/* eslint-disable object-curly-newline */
import React, { useState, useContext, useRef } from 'react';
import PropTypes from 'prop-types';
import { Modal, Box } from '@mui/material';
import { CSVLink } from 'react-csv';
// eslint-disable-next-line import/no-extraneous-dependencies
import { UploadCloud, FileText, X } from 'lucide-react';
import { sendRequest } from '../../api/shootAPI';
import API from '../../api/endpoints';
import { UserContext } from '../../contexts/User';
import { NotificationContext } from '../../contexts/Notification';
import { getTimeString } from '../../utils/time';

function ImportModal({ closeModal, data, headers, getMembers }) {
  const { activeWorkspace } = useContext(UserContext);
  const { displayNotification } = useContext(NotificationContext);
  const [reason, setReason] = useState('');
  const [file, setFile] = useState();
  const [array, setArray] = useState([]);
  const fileInputRef = useRef(null);
  const fileReader = new FileReader();

  const csvFileToArray = (string) => {
    const newString = string.replaceAll('\r', '');
    const csvHeader = newString.slice(0, newString.indexOf('\n')).split(',');
    const csvRows = newString.slice(newString.indexOf('\n') + 1).split('\n');
    const parsed = csvRows.map((i) => {
      const values = i.split(',');
      return csvHeader.reduce((object, header, index) => {
        const newHeader = header.replaceAll('"', '');
        const newValue = values[index].replaceAll('"', '');
        let updatedHeader = '';
        switch (newHeader) {
          case 'Balance': updatedHeader = 'balance'; break;
          case 'Policy': updatedHeader = 'policy'; break;
          case 'User Email': updatedHeader = 'email'; break;
          default: updatedHeader = 'name';
        }
        return { ...object, [updatedHeader]: newValue };
      }, {});
    });
    setArray(parsed);
  };

  const handleImport = () => {
    fileReader.onload = (event) => csvFileToArray(event.target.result);
    fileReader.readAsText(file);
  };

  const handleConfirm = async () => {
    if (!activeWorkspace) return;
    closeModal();
    const response = await sendRequest({ method: 'post', url: API.WORKSPACE.editMembersBalances(activeWorkspace.id), data: array });
    if (response.success) {
      displayNotification({ message: 'Time off balances updated successfully.', severity: 'success' });
      getMembers();
    } else {
      displayNotification({ message: 'An error occurs while editing data.', severity: 'error' });
    }
  };

  const thCls = 'text-left text-[11px] font-semibold uppercase tracking-wider text-ink-500';

  return (
    <Modal open onClose={closeModal} className="flex-row align-c jstfy-c">
      <Box style={{ width: 588, maxWidth: 'calc(100% - 32px)', maxHeight: '90vh', overflowY: 'auto', padding: 24, background: '#fff', borderRadius: 12 }}>
        <h5 className="text-lg font-semibold leading-none text-ink-900 mb-4">Import Balances</h5>

        <div className="flex items-center justify-between mb-2">
          <span className="text-sm font-medium text-ink-900">Upload File</span>
          <CSVLink data={data} headers={headers} filename="timeOffBalance.csv" style={{ textDecoration: 'none' }}>
            <span className="text-sm font-medium text-brand-700 hover:underline">Download Spreadsheet Template</span>
          </CSVLink>
        </div>

        {file ? (
          <div className="flex items-center justify-between rounded-[8px] border border-rule px-3" style={{ borderStyle: 'solid', height: 48 }}>
            <span className="inline-flex items-center gap-2 text-sm text-ink-900 min-w-0">
              <FileText size={16} className="text-ink-500 flex-shrink-0" />
              <span className="truncate">{file.name}</span>
            </span>
            <button type="button" aria-label="Remove file" onClick={() => { setFile(); setArray([]); }} className="text-ink-500 hover:text-ink-900 bg-transparent border-0 cursor-pointer flex-shrink-0">
              <X size={16} />
            </button>
          </div>
        ) : (
          <div
            onClick={() => fileInputRef.current.click()}
            className="flex items-center justify-center gap-2 rounded-[8px] cursor-pointer text-sm text-ink-700"
            style={{ border: '2px dashed #c7cbd6', height: 48 }}
          >
            <UploadCloud size={16} className="text-ink-500" />
            <span>Drop your .csv file here or</span>
            <span className="text-brand-700 underline">Browse</span>
            <input ref={fileInputRef} type="file" id="csvFileInput" style={{ display: 'none' }} onChange={(e) => setFile(e.target.files[0])} accept=".csv" />
          </div>
        )}

        {array.length > 0 && (
          <div className="rounded-[8px] border border-rule overflow-auto mt-4" style={{ borderStyle: 'solid', maxHeight: 360 }}>
            <table className="w-full" style={{ borderCollapse: 'collapse' }}>
              <thead>
                <tr className="bg-surface-page">
                  <th className={thCls} style={{ padding: '10px 12px' }}>User</th>
                  <th className={thCls} style={{ padding: '10px 12px' }}>Policy</th>
                  <th className={thCls} style={{ padding: '10px 12px' }}>Old</th>
                  <th className={thCls} style={{ padding: '10px 12px' }}>New</th>
                </tr>
              </thead>
              <tbody>
                {array.map((upload, index) => {
                  const match = data.find((datum) => datum.email === upload.email && datum.policy === upload.policy);
                  return (
                    <tr key={index} className="border-t border-rule" style={{ borderTopStyle: 'solid' }}>
                      <td className="text-sm text-ink-900" style={{ padding: '10px 12px' }}>{upload.name}</td>
                      <td className="text-sm text-ink-700" style={{ padding: '10px 12px' }}>{upload.policy}</td>
                      <td className="text-sm text-ink-500 tabular-nums" style={{ padding: '10px 12px' }}>{match ? getTimeString(match.balance) : '—'}</td>
                      <td className="text-sm text-ink-900 tabular-nums" style={{ padding: '10px 12px' }}>{match ? getTimeString(upload.balance) : upload.balance}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}

        <div className="mt-4">
          <span className="block text-sm font-medium text-ink-900 mb-1.5">Reason for Balance Adjustment</span>
          <textarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Required"
            className="w-full box-border px-3 py-2 border border-rule rounded-[8px] text-sm text-ink-900 placeholder:text-ink-500 focus:outline-none focus:border-brand-500"
            style={{ borderStyle: 'solid', minHeight: 80, resize: 'vertical' }}
          />
        </div>

        <div className="flex justify-start items-center gap-2 mt-6">
          <button type="button" onClick={closeModal} className="inline-flex items-center justify-center box-border h-10 px-4 border border-rule rounded-[8px] text-sm font-medium text-ink-900 bg-white hover:bg-gray-50 transition" style={{ borderStyle: 'solid' }}>Cancel</button>
          <button type="button" onClick={() => (array.length > 0 ? handleConfirm() : handleImport())} disabled={!file} className="inline-flex items-center justify-center box-border h-10 px-4 bg-[#53A551] text-white rounded-[8px] text-sm font-semibold hover:bg-[#458a44] disabled:opacity-40 disabled:cursor-not-allowed transition">
            {array.length > 0 ? 'Confirm' : 'Import'}
          </button>
        </div>
      </Box>
    </Modal>
  );
}

ImportModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  getMembers: PropTypes.func.isRequired,
  data: PropTypes.arrayOf(PropTypes.shape({}).isRequired),
  headers: PropTypes.arrayOf(PropTypes.shape({}).isRequired),
};

ImportModal.defaultProps = { data: [], headers: [] };

export default ImportModal;
